const sizes = {
    medium: { spacing: "gap-2.5 px-4 py-2.5", label: "text-xs", name: "text-base", icon: 26 },
    small: { spacing: "gap-2 px-3 py-1.5", label: "text-[10px]", name: "text-sm", icon: 20 },
};

/**
 * Bouton de telechargement vers un store.
 *
 * @param size "medium" | "small" — "small" sert aux emplacements ou le bouton
 * accompagne un texte, comme la mention en bas de la home preteur.
 */
const StoreDownloadButton = ({ href, Icon, iconSize, storeLabel, storeName, ariaLabel, size = "medium", className = "" }) => {
    const currentSize = sizes[size] || sizes.medium;

    return (
        <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={ariaLabel}
            className={`inline-flex items-center rounded-lg bg-black text-white transition hover:-translate-y-0.5 hover:opacity-90 ${currentSize.spacing} ${className}`}
        >
            {Icon && <Icon size={iconSize || currentSize.icon} className="flex-shrink-0" />}
            <span className="flex flex-col leading-tight">
                <span className={`${currentSize.label} opacity-85`}>{storeLabel}</span>
                <span className={`${currentSize.name} font-semibold`}>{storeName}</span>
            </span>
        </a>
    );
};

export default StoreDownloadButton;
